var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 24,
    viewBox: "10 0 45 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12C21 5.37258 26.3726 0 33 0C39.6274 0 45 5.37258 45 12C45 18.6274 39.6274 24 33 24C26.3726 24 21 18.6274 21 12ZM37.575 8.625C38.1 8.55 38.55 8.475 39 8.25C38.7 8.775 38.25 9.225 37.725 9.525C37.875 13.05 35.325 16.875 30.75 16.875C29.4 16.875 28.125 16.425 27 15.75C28.275 15.9 29.625 15.525 30.525 14.85C29.4 14.85 28.5 14.1 28.2 13.125C28.575 13.2 28.95 13.125 29.325 13.05C28.2 12.75 27.375 11.7 27.375 10.575C27.75 10.725 28.125 10.875 28.5 10.875C27.45 10.125 27.075 8.7 27.75 7.575C29.025 9.075 30.825 10.05 32.85 10.125C32.475 8.625 33.675 7.125 35.25 7.125C35.925 7.125 36.6 7.425 37.05 7.875C37.65 7.725 38.175 7.575 38.625 7.275C38.475 7.875 38.1 8.325 37.575 8.625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.53447dbd0353fbeadde3b68aff447306.svg";
export { ForwardRef as ReactComponent };